<!-- <div  *ngIf="false" class="spinner-wrapper">
    <mis-loader [mobileView]="false"></mis-loader>
</div> -->

<div  class="side-bar d-flex flex-dir-col">

    <div class="child-1 d-flex align-center">
        <div><img [src]="imgSrc + 'assets/icons/left-arrow.svg'" alt=""></div>
        <div class="d-flex align-center gap-8">
            <span class="h5">UA3282</span>
        </div>
    </div>

    <div class="child-2 d-flex flex-dir-col gap-8">
        <div class="d-flex gap-8 align-center pb-4">
            <div class="pointer-cursor d-flex align-center" [@expandedAnimation]="expandedToggler ? 'true' : 'false'"    (click)="expandedToggle()">
                <img [@rotateArrow]="expandedToggler ? 'true' : 'false'" [src]="imgSrc + 'assets/icons/down-arrow1.svg'" alt=""   >
            </div>
            <div><span class="h7-b grey">Driver details</span></div>
        </div>
        <div [@expandCollapse]="expandedToggler ? 'expanded' : 'collapsed'">
            <app-driver-card></app-driver-card>
        </div>
   </div>

   <div class="child-3 d-flex flex-dir-col ">
    <app-attendance-card></app-attendance-card>
   </div>


 
</div>
